INPUT_OBJECT_TYPE_EXTENSION